import { fallback, http, type Config } from "wagmi";

import { arbitrum, mainnet } from "wagmi/chains";

import { createAppKit } from "@reown/appkit/react";

import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";

import { getRPCURL } from "@bracket/chainography";

const projectId = "041af0b969c39f4de7db2aaaeb58b8f8";

const metadata = {
	name: "Bracket.fi App",
	description: "Bracket.fi Staking Application",
	url: "https://bracket.fi",
	icons: ["https://bracket.fi/favicon.ico"],
};

const PUBLIC_HOSTS = [
	"stake.bracket.fi",
	"prod1-stake.bracket.fi",
	"prod2-stake.bracket.fi",
	// "localhost:5173",
	// "localhost:5174",
];

const { VITE_APP_ALCHEMY_API_KEY, } = import.meta.env;

const [
	CHAIN_1_RPC,
	CHAIN_42161_RPC, 
] = PUBLIC_HOSTS.includes(globalThis.location.hostname)
? [
	`https://eth-mainnet.g.alchemy.com/v2/${VITE_APP_ALCHEMY_API_KEY}`,
	`https://arb-mainnet.g.alchemy.com/v2/${VITE_APP_ALCHEMY_API_KEY}`,
]
: [
	getRPCURL(1),
	getRPCURL(42161),
];

const wagmiAdapter = new WagmiAdapter({
	networks: [mainnet, arbitrum],
	projectId,
	ssr: false,
	transports: {
		[mainnet.id]: fallback([
			http(CHAIN_1_RPC),
			http("https://ethereum-rpc.publicnode.com"),
		]),
		[arbitrum.id]: fallback([
			http(CHAIN_42161_RPC),
			http("https://arb1.arbitrum.io/rpc"),
		]),
	},
});

createAppKit({
	adapters: [wagmiAdapter],
	networks: [mainnet, arbitrum],
	projectId,
	metadata,
	featuredWalletIds: [
		"38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662", //bitget
	],
	includeWalletIds: [
		"38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662", //bitget
		"c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96", //metamask
		"971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709", //okx
		"1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369", //rainbow
		"8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4", //binance
		"aba1f652e61fd536e8a7a5cd5e0319c9047c435ef8f7e907717361ff33bb3588", //gate
		"18388be9ac2d02726dbac9777c96efaac06d744b2f6d580fccdd4127a6d01fd1", // rabby
		"163d2cf19babf05eb8962e9748f9ebe613ed52ebf9c8107c9a0f104bfcf161b3", // brave
		"fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa", //coinbase
	],
	features: {
		swaps: false,
		onramp: false,
		email: false,
		emailShowWallets: false,
		socials: false,
		history: false,
		analytics: false,
		allWallets: false,
		smartSessions: false,
	},
});

export const wagmiConfig = wagmiAdapter.wagmiConfig as Config;
